"use strict";'use strict';

var chunkTBIRXQOL_js = require('./chunk-TBIRXQOL.js');
require('./chunk-URKELHWL.js');



module.exports = chunkTBIRXQOL_js.ChevronRight_default;
